import styled from 'styled-components';
import ActionButton from 'components/ui/Button';

export const StyledButton = styled(ActionButton)`
  display: block;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: calc(100vh - 75px);
`;

export const StyledNavigationContainer = styled.div`
  align-content: center;
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
`;

export const StyledDisruptionMessages = styled.div`
  align-self: stretch;
  display: flex;
  flex-direction: column;
  margin: 25px 25px 0;

  > div:not(:last-of-type) {
    margin-bottom: 8px;
  }
`;
